(()=>{
const root=document.querySelector('.wk[data-page="workouts"]');
if(!root)return;
const $=selector=>root.querySelector(selector);
const rawLang=document.documentElement.lang||'en';
let dict={};
try{dict=JSON.parse($('#wk-i18n').textContent)||{};}catch(e){dict={};}
const t=(key,vars)=>{let text=dict[key]||key;if(vars)for(const name in vars)text=text.split('{'+name+'}').join(vars[name]);return text;};

/* Tabbed viewer */
let features={};
try{features=JSON.parse($('#wk-feature-data').textContent)||{};}catch(e){features={};}
const tabs=Array.from(root.querySelectorAll('[data-feature]'));
function choose(tab,focus){
 const f=features[tab.dataset.feature];if(!f)return;
 tabs.forEach(x=>{x.setAttribute('aria-selected',String(x===tab));x.tabIndex=x===tab?0:-1;});
 $('#wk-feature-panel').setAttribute('aria-labelledby',tab.id);
 const img=$('#wk-feature-image');img.src=f['1680'];img.srcset=f['840']+' 840w, '+f['1680']+' 1680w';img.alt=f.alt;
 $('#wk-feature-title').textContent=f.title;$('#wk-feature-body').textContent=f.body;$('#wk-feature-note').textContent=f.note;
 $('.wk-feature-number').textContent='0'+(tabs.indexOf(tab)+1)+' / 03';
 if(focus)tab.focus();
}
tabs.forEach((tab,i)=>{
 tab.addEventListener('click',()=>choose(tab));
 tab.addEventListener('keydown',event=>{
  const next={ArrowRight:(i+1)%tabs.length,ArrowLeft:(i+tabs.length-1)%tabs.length,Home:0,End:tabs.length-1}[event.key];
  if(next!==undefined){event.preventDefault();choose(tabs[next],true);}
 });
});

/* Mobile sticky action */
const sticky=$('.wk-mobile-action');const visible=new Map();
if(sticky&&'IntersectionObserver' in window){
 const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>visible.set(entry.target,entry.isIntersecting));sticky.hidden=[...visible.values()].some(Boolean);},{threshold:.05});
 [$('.wk-hero'),$('#wk-setup'),$('#wk-demo'),$('.wk-close')].forEach(section=>{if(section)observer.observe(section);});
}

/* Movement library */
const lib=$('#wk-library'),grid=$('#wk-grid'),chipsEl=$('#wk-chips'),moreBtn=$('#wk-more'),statusEl=$('#wk-status'),filterWrap=$('.wk-filter');
const dlg=$('#wk-dialog'),dlgVideo=$('#wk-dialog-video');
const mq=window.matchMedia('(max-width:767px)');
const step=()=>mq.matches?6:9;
const items=[],seen=new Set();
const clean=text=>String(text||'').replace(/\bpul{2}s\b/gi,match=>match===match.toUpperCase()?'PULL':match[0]==='P'?'Pull':'pull');
let tag='',shown=step(),rendered=0,pendingTag=null,pagesPending=false,lastFocus=null,tags=[];
function ingest(list){
 (list||[]).forEach(it=>{
  if(!it||!it.t)return;
  const key=it.id||it.t;
  if(seen.has(key))return;
  seen.add(key);
  it.r=(Array.isArray(it.g)?it.g:[]).map(value=>String(value).trim());
  it.g=it.r.filter(Boolean);
  it.t=clean(it.t);it.d=clean(it.d);
  items.push(it);
 });
}
function filtered(){return tag?items.filter(it=>it.g.includes(tag)):items;}
function updateEnd(){
 if(!chipsEl||!filterWrap)return;
 const end=chipsEl.scrollLeft+chipsEl.clientWidth>=chipsEl.scrollWidth-4;
 filterWrap.toggleAttribute('data-end',end);
}
function renderChips(){
 tags=[...new Set(items.flatMap(it=>it.g))].sort((a,b)=>a.localeCompare(b,rawLang));
 const make=(label,value)=>{
  const b=document.createElement('button');
  b.type='button';b.className='wk-chip';b.textContent=label;b.dataset.tag=value;
  b.setAttribute('aria-pressed',String(value===tag));
  b.addEventListener('click',()=>{pendingTag=null;setTag(value,true);});
  return b;
 };
 const focused=chipsEl.contains(document.activeElement)&&document.activeElement.dataset?document.activeElement.dataset.tag:undefined;
 chipsEl.replaceChildren(make(t('all'),''),...tags.map(x=>make(x,x)));
 if(focused!==undefined){const again=Array.from(chipsEl.children).find(chip=>chip.dataset.tag===focused);if(again)again.focus({preventScroll:true});}
 updateEnd();
}
function card(it){
 const li=document.createElement('li');
 const b=document.createElement('button');
 b.type='button';b.className='wk-card';b.setAttribute('aria-haspopup','dialog');b.setAttribute('aria-label',t('watch',{title:it.t}));
 const poster=document.createElement('span');poster.className='wk-card-poster';
 const img=document.createElement('img');img.src=it.p||'';img.alt='';img.width=600;img.height=600;img.loading='lazy';img.decoding='async';
 const play=document.createElement('span');play.className='wk-card-play';play.setAttribute('aria-hidden','true');play.textContent='▷';
 poster.append(img,play);
 const title=document.createElement('span');title.className='wk-card-title';title.textContent=it.t;
 const meta=document.createElement('span');meta.className='wk-card-tags';meta.textContent=it.g.join(', ');
 b.append(poster,title,meta);
 b.addEventListener('click',()=>openVideo(it,b));
 li.append(b);
 return li;
}
function updateMore(){const total=filtered().length;moreBtn.hidden=total<=shown;}
function renderGrid(){
 const list=filtered();
 const vis=list.slice(0,shown);
 if(!vis.length){
  const li=document.createElement('li');li.className='wk-empty';li.textContent=t('empty');grid.replaceChildren(li);
 }else{grid.replaceChildren(...vis.map(card));}
 rendered=vis.length;
 lib.setAttribute('data-ready','');
 updateMore();
}
function setTag(value,announce){
 const match=value?tags.find(x=>x.toLowerCase()===String(value).toLowerCase()):'';
 tag=match||'';
 shown=step();
 chipsEl.querySelectorAll('.wk-chip').forEach(chip=>{
  const on=chip.dataset.tag===tag;
  chip.setAttribute('aria-pressed',String(on));
  if(on&&chipsEl.scrollWidth>chipsEl.clientWidth)chipsEl.scrollLeft=Math.max(0,chip.offsetLeft-(chipsEl.clientWidth-chip.offsetWidth)/2);
 });
 renderGrid();
 updateEnd();
 if(announce)statusEl.textContent=tag?t('status_tag',{tag}):t('status_all');
}
moreBtn.addEventListener('click',()=>{
 const list=filtered();
 const from=rendered;
 shown+=step();
 const next=list.slice(from,shown);
 const nodes=next.map(card);
 nodes.forEach(n=>grid.append(n));
 rendered=Math.min(shown,list.length);
 updateMore();
 const first=nodes[0]&&nodes[0].querySelector('button');
 if(first)first.focus({preventScroll:false});
});
chipsEl.addEventListener('scroll',updateEnd,{passive:true});
window.addEventListener('resize',updateEnd);

function pickSource(it){
 if(it.v)return it.v;
 const list=(it.s||[]).slice().sort((a,b)=>a.h-b.h);
 if(!list.length)return '';
 const target=mq.matches?480:720;
 return (list.find(x=>x.h>=target)||list[list.length-1]).u;
}
function openVideo(it,invoker){
 const src=pickSource(it);
 if(!src)return;
 if(typeof dlg.showModal!=='function'){window.open(src,'_blank','noopener');return;}
 lastFocus=invoker;
 $('#wk-dialog-title').textContent=it.t;
 $('#wk-dialog-tags').textContent=it.g.join(', ');
 const desc=$('#wk-dialog-desc');desc.textContent=it.d||'';desc.hidden=!it.d;
 dlgVideo.setAttribute('aria-label',t('video_label',{title:it.t}));
 dlgVideo.poster=(it.p||'').replace(/width=\d+/,'width=900');
 dlgVideo.src=src;dlgVideo.load();
 dlg.showModal();
}
function resetVideo(){
 dlgVideo.pause();
 dlgVideo.removeAttribute('src');
 dlgVideo.removeAttribute('poster');
 dlgVideo.load();
}
$('#wk-dialog-close').addEventListener('click',()=>dlg.close());
dlg.addEventListener('click',event=>{if(event.target===dlg)dlg.close();});
dlg.addEventListener('close',()=>{resetVideo();if(lastFocus){lastFocus.focus();lastFocus=null;}});

function readData(scope){
 const out=[];
 scope.querySelectorAll('script.wk-data').forEach(script=>{try{out.push(...JSON.parse(script.textContent));}catch(e){}});
 return out;
}
function pageUrl(href){
 const url=new URL(href,location.href);
 new URLSearchParams(location.search).forEach((value,key)=>{if(!key.startsWith('page_')&&!url.searchParams.has(key))url.searchParams.set(key,value);});
 return url.href;
}
function afterIngest(){
 renderChips();
 if(pendingTag){const want=pendingTag;pendingTag=null;setTag(want,true);return;}
 const list=filtered();
 if(rendered<Math.min(shown,list.length))renderGrid();else updateMore();
}
ingest(readData(root));
renderChips();
setTag('',false);
/* Goal cards: the locale-independent key is an anchor (item id and tag position, same order in every language); the English label is the fallback. */
function goalTag(link){
 const anchors=String(link.dataset.wkAnchor||'').split(',').filter(Boolean);
 for(const anchor of anchors){
  const parts=anchor.split(':');
  const item=items.find(x=>String(x.id)===parts[0]);
  const value=item&&item.r&&item.r[Number(parts[1])];
  if(value)return value;
 }
 return link.dataset.wkFilter||'';
}
root.querySelectorAll('[data-wk-filter]').forEach(link=>link.addEventListener('click',()=>{
 const want=goalTag(link);
 /* The tag may only exist on a page that has not arrived yet: remember it and apply it when the pages land. */
 if(pagesPending&&!tags.some(x=>x.toLowerCase()===String(want).toLowerCase())){pendingTag=want;return;}
 setTag(want,true);
}));
const pagesEl=$('#wk-pages');
const hrefs=Array.from(root.querySelectorAll('#wk-pages [data-href]')).map(el=>el.dataset.href).filter(Boolean);
const sectionId=pagesEl?pagesEl.dataset.section:'';
const wait=ms=>new Promise(resolve=>setTimeout(resolve,ms));
function fetchData(url){return fetch(url,{credentials:'same-origin'}).then(r=>{if(!r.ok)throw new Error('Unavailable');return r.text();}).then(html=>readData(new DOMParser().parseFromString(html,'text/html')));}
/* Page 2+ through the Section Rendering API (about 40 KB instead of the whole page); the full page is the fallback. Failed requests retry once after 2 s. */
function fetchPageData(href){
 const full=pageUrl(href);
 const viaSection=sectionId?(()=>{const url=new URL(full);url.searchParams.set('section_id',sectionId);return url.href;})():'';
 const attempt=()=>(viaSection?fetchData(viaSection).catch(()=>[]).then(list=>list.length?list:fetchData(full)):fetchData(full));
 return attempt().catch(()=>wait(2000).then(attempt)).catch(()=>[]);
}
if(hrefs.length){
 pagesPending=true;
 const load=()=>Promise.all(hrefs.map(fetchPageData)).then(pages=>{
  pagesPending=false;
  pages.forEach(ingest);
  afterIngest();
 });
 if('requestIdleCallback' in window)requestIdleCallback(load,{timeout:2500});else setTimeout(load,1200);
}

/* Live price, saving, rating and Premium Care value from the store's own product data */
const studioOn=root.dataset.studioAvailable!=='false';
const abort=new AbortController();const timer=setTimeout(()=>abort.abort(),8000);
const routeRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
function fetchProduct(handle){
 return fetch(routeRoot+'products/'+handle+'.js',{signal:abort.signal}).then(response=>{if(!response.ok)throw new Error('Unavailable');return response.json();});
}
if(studioOn)Promise.all([
 fetchProduct('speediance-gym-monster-3'),
 fetchProduct('speediance-premium-care-2-year-in-home-service-plan').catch(()=>null)
]).then(([product,premiumCare])=>{
 const variants=(product.variants||[]).filter(v=>v.available&&Number(v.price)>0);
 /* Locale-independent keys first (variant id from the server render, then SKU); the English title is the last fallback. */
 const wantId=root.dataset.studioVariant,wantSku=root.dataset.studioSku;
 const variant=(wantId&&variants.find(v=>String(v.id)===wantId))||(wantSku&&variants.find(v=>v.sku===wantSku))||variants.find(v=>(v.public_title||v.title||'').trim().toLowerCase()==='gym monster 3 / studio');
 if(!variant)return;
 const currency=product.currency||(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active);
 if(!currency)return;
 const money=amount=>new Intl.NumberFormat(rawLang,{style:'currency',currency,currencyDisplay:'narrowSymbol',minimumFractionDigits:amount%100?2:0,maximumFractionDigits:2}).format(amount/100);
 /* House VAT rule: EU prices are ex-VAT; show them including the visitor's VAT (rounded up to a whole unit) where checkout charges it. */
 const vat=Number(root.dataset.vat)||0;
 const withVat=cents=>vat?Math.ceil(cents*(1000+vat)/100000)*100:cents;
 const price=withVat(Number(variant.price)),compareAt=Number(variant.compare_at_price||0)?withVat(Number(variant.compare_at_price)):0;
 const hasSaving=compareAt>price;
 const save=hasSaving?compareAt-price:0;
 const priceText=money(price);
 const productUrl=routeRoot+'products/speediance-gym-monster-3?variant='+encodeURIComponent(variant.id);
 const priceEl=$('#wk-price');priceEl.textContent=priceText;priceEl.href=productUrl;
 const taxNote=$('#wk-price-note');if(taxNote&&root.dataset.showTax!=='false')taxNote.textContent=t('tax');
 if(hasSaving){
  $('#wk-price-compare-value').textContent=money(compareAt);$('#wk-price-compare').hidden=false;
  const saveEl=$('#wk-price-save');saveEl.textContent=t('save_chip',{save:money(save)});saveEl.hidden=false;
 }
 const ctaText=hasSaving?t('cta_save',{save:money(save)}):t('cta_default');
 [$('#wk-hero-cta'),$('#wk-ways-cta')].forEach(a=>{if(a){a.textContent=ctaText;a.href=productUrl;}});
 const productLink=$('#wk-product-link');productLink.href=productUrl;productLink.innerHTML=(hasSaving?t('product_save',{price:priceText}):t('product_default'))+' <span aria-hidden="true">→</span>';
 const closeCta=$('#wk-close-cta');closeCta.textContent=hasSaving?t('close_save',{save:money(save)}):t('cta_default');closeCta.href=productUrl;
 if(sticky){sticky.innerHTML=(hasSaving?t('sticky_save',{save:money(save)}):t('sticky_default'))+' <span aria-hidden="true">→</span>';sticky.href=productUrl;}
 if(variant.featured_image&&variant.featured_image.src){const productImg=$('#wk-product-image');if(productImg)productImg.src=variant.featured_image.src;}
 const careVariant=premiumCare&&Array.isArray(premiumCare.variants)?premiumCare.variants[0]:null;
 const careValue=careVariant&&Number(careVariant.price)>0?money(withVat(Number(careVariant.price))):null;
 const tick=$('#wk-tick-care-value');
 if(tick)tick.textContent=careValue?t('care_value',{value:careValue}):'';
}).catch(()=>{}).finally(()=>clearTimeout(timer));

/* Rating: the server renders the Loox average as data-avg (no product-page fetch); the script only formats it and fills the stars. */
const ratingEl=$('#wk-rating');
if(ratingEl&&studioOn){
 const average=Number(ratingEl.dataset.avg);
 if(average>=1&&average<=5){
  const textEl=$('#wk-rating-text'),stars=$('#wk-stars');
  if(textEl){textEl.textContent=t('rating',{rating:average.toLocaleString(rawLang,{minimumFractionDigits:1,maximumFractionDigits:1})});}
  if(stars)stars.style.setProperty('--wk-fill',(average/5*100).toFixed(1)+'%');
  ratingEl.hidden=false;
 }
}
})();
